import { piecesInPosition } from "./rules";

export const classifyGamePhase = (fen: string): "opening" | "middlegame" | "endgame" => {
  const fields = fen.trim().split(/\s+/);
  const pieces = piecesInPosition(fen);
  const fullmove = Number(fields[5]);
  if (
    fields.length !== 6 ||
    pieces.filter(({ role }) => role === "king").length !== 2 ||
    !Number.isInteger(fullmove) ||
    fullmove < 1
  )
    throw new Error("Invalid FEN");

  const queens = pieces.filter(({ role }) => role === "queen").length;
  const nonPawnNonKingPieces = pieces.filter(({ role }) => role !== "pawn" && role !== "king").length;
  if (queens === 0 && nonPawnNonKingPieces <= 4) return "endgame";
  return fullmove <= 12 ? "opening" : "middlegame";
};
